import {HideProps, Hide} from 'platform/foundation';

export function HideOnMobileNavigation(props: HideProps) {
  return <Hide onMobile onTablet {...props} />;
}
